<label class="input-color" :class="value | foregroundClass" :style="!!value ? `--value:${value}` : ''" :for="id" :title="title" :disabled="disabled">
	<input type="color" :id="id" :value="value" @input="handleInput($event.target.value)" :disabled="disabled">
	<span :class="{'text-placeholder': !value}">{{ value || placeholder }}</span>
</label>
